.riskStrategyContainer { 
    display: flex;
    align-items: flex-end;
}

.riskStrategyName {
    width: 50%;
}
